import { render, staticRenderFns } from "./AddFacility.vue?vue&type=template&id=48724b0c&"
import script from "./AddFacility.js?vue&type=script&lang=js&"
export * from "./AddFacility.js?vue&type=script&lang=js&"
import style0 from "./AddFacility.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports